module.exports = __webpack_public_path__ + "static/media/Usman.808f6e98.png";